import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrows-vertical', 'ArrowsVertical', [["path",{"d":"M8 7l4 -4l4 4"}],["path",{"d":"M8 17l4 4l4 -4"}],["path",{"d":"M12 3l0 18"}]]);